import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  googleAuth: (token) => api.post('/auth/google/', { token }),
  getCurrentUser: () => api.get('/auth/me/'),
};

// Users endpoints
export const usersAPI = {
  getUsers: (params) => api.get('/users/', { params }),
  getUser: (userId) => api.get(`/users/${userId}/`),
  createUser: (data) => api.post('/users/', data),
  updateUser: (userId, data) => api.put(`/users/${userId}/`, data),
  deleteUser: (userId) => api.delete(`/users/${userId}/`),
  getUsersByRole: (role) => api.get(`/users/role/${role}/`),
};

// Projects endpoints
export const projectsAPI = {
  getProjects: (params) => api.get('/projects/', { params }),
  getProject: (projectId) => api.get(`/projects/${projectId}/`),
  createProject: (data) => api.post('/projects/', data),
  updateProject: (projectId, data) => api.put(`/projects/${projectId}/`, data),
  deleteProject: (projectId) => api.delete(`/projects/${projectId}/`),
  getUserBugStats: (projectId) => api.get(`/projects/${projectId}/user-bug-stats/`),
};

// Bugs endpoints
export const bugsAPI = {
  getBugs: (params) => api.get('/bugs/', { params }),
  getBug: (bugId) => api.get(`/bugs/${bugId}/`),
  createBug: (data) => api.post('/bugs/', data),
  updateBug: (bugId, data) => api.put(`/bugs/${bugId}/`, data),
  deleteBug: (bugId) => api.delete(`/bugs/${bugId}/`),
  getBugAttachments: (bugId) => api.get(`/bugs/${bugId}/attachments/`),
  uploadAttachment: (bugId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/bugs/${bugId}/attachments/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// Comments endpoints
export const commentsAPI = {
  getBugComments: (bugId) => api.get(`/comments/bug/${bugId}/`),
  createComment: (data) => api.post('/comments/', data),
  updateComment: (commentId, data) => api.put(`/comments/${commentId}/`, data),
  deleteComment: (commentId) => api.delete(`/comments/${commentId}/`),
};

// Dashboard endpoints
export const dashboardAPI = {
  getMetrics: () => api.get('/dashboard/metrics/'),
  getProjectMetrics: () => api.get('/dashboard/projects/'),
};

export default api;
